// Basque translations
export const eu: Record<string, string> = {
  'menu.dashboard': 'Aginte-panela',
  'menu.customers': 'Bezeroak',
  'menu.products': 'Produktuak',
  'menu.users': 'Erabiltzaileak',
  'menu.settings': 'Ezarpenak',
  'menu.logout': 'Irten',
  'dashboard.title': 'Aginte-panela',
  'dashboard.newOrder': 'Eskaera berria',
  'order.title': 'Eskaera berria',
  'order.customer': 'Bezeroa',
  'order.products': 'Produktuak',
  'order.total': 'Guztira',
  'users.title': 'Erabiltzaileak',
  'users.name': 'Izena',
  'users.email': 'Posta elektronikoa',
  'common.yes': 'Bai',
  'common.no': 'Ez',
  'common.cancel': 'Ezeztatu',
  'common.save': 'Gorde',
  'common.search': 'Bilatu',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Saioa hasi',
  'login.welcome': 'Ongi etorri, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Posta elektronikoa',
  'signup.phone': 'Telefonoa',
  'menu.reportsAndAccounting': 'Txostenak eta kontabilitatea',
  'menu.systemAndCommunication': 'Sistema eta komunikazioa',
};